module.exports = __webpack_public_path__ + "img/03.831e4de2.jpg";